import styles from "./style.module.scss";
import YakisobaImage1 from "src/assets/activity/yakisoba/01.jpg";
import YakisobaImage2 from "src/assets/activity/yakisoba/02.jpg";
import YakisobaImage3 from "src/assets/activity/yakisoba/03.jpg";
import YakisobaImage4 from "src/assets/activity/yakisoba/04.jpg";
import YakisobaImage5 from "src/assets/activity/yakisoba/05.jpg";
import YakisobaImage6 from "src/assets/activity/yakisoba/06.jpg";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const IMAGES = [
  YakisobaImage1,
  YakisobaImage2,
  YakisobaImage3,
  YakisobaImage4,
  YakisobaImage5,
  YakisobaImage6,
];

export const YakisobaSection = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
  };

  return (
    <section className={styles.container}>
      <div className={styles.innerBox}>
        <p className={styles.caption}>
          石巻マリンヴィレッジに宿泊すると、以下のような体験が可能です。
          <br />
          なお、体験は宿泊予約ページで宿泊と一緒にご予約ください。
        </p>
        <p id="yakisoba" className={styles.sectionTitle}>
          買い物から調理まで！元﻿祖石巻焼そばづくり
        </p>
        <Slider {...settings}>
          {IMAGES.map((src, i) => (
            <img src={src} alt={`slide-${i}`} key={i} />
          ))}
        </Slider>
        <p className={styles.description}>
          ご当地のスーパーマーケットで食材を買い出し、ヴィレッジのキッチンで石巻名物「元祖石巻焼そば」を一緒に作る地域の食の体験です。せいろで二度蒸しすることで麺が茶色になる、魚介だしで蒸し焼きにするなど、有限会社島金商店（昭和25年創業）の独自の焼きそばを自分たちで作ることができます。当日は「石巻茶色い焼そばアカデミー」の検定に合格したスタッフがサポートします。
        </p>
        <h3>information -詳細情報-</h3>

        <ul>
          <li>
            <p className={styles.head}>体験場所</p>
            <p className={styles.body}>石巻マリンヴィレッジ内</p>
          </li>
          <li>
            <p className={styles.head}>体験人数</p>
            <p className={styles.body}>2〜4名</p>
          </li>
          <li>
            <p className={styles.head}>体験可能時間</p>
            <p className={styles.body}>18:00〜22:00</p>
          </li>
          <li>
            <p className={styles.head}>所要時間</p>
            <p className={styles.body}>2〜3時間</p>
          </li>
          <li>
            <p className={styles.head}>料金</p>
            <p className={styles.body}>10,000円（食材費込み）</p>
          </li>
          <li>
            <p className={styles.head}>予約方法</p>
            <p className={styles.body}>
              <Link to="/reservation">ご予約ページ</Link>で選択ください
            </p>
          </li>
        </ul>
        <p className={styles.ulInfo}>
          ※料金は時期などによって変動する可能性があるため、詳しくは店舗にご確認ください。
        </p>
      </div>
    </section>
  );
};
